import React,{Component} from 'react';
import {firestore} from '../firebase/firebase.utils'
class Requests extends Component {
	constructor(){
		super();
		this.state = {

		}
	}
    onAccept = (transferTo,subtractFrom,amount) =>{
        var c = {}
         var ff = {}
      var docId = ''
      const {user} = this.props
      if(amount<parseInt(user.entries)){
      firestore.collection("users").where('email','==',transferTo).get()
          .then(function(querySnapshot) {
              querySnapshot.forEach(async function(doc) {
                  c = doc.data()
                  docId = doc.id;
              });
              let o = parseInt(c.entries) + parseInt(amount)
              let h = c.receivedRequests
              console.log(h);
              const found = h.find(element => element.requestId === transferTo);
              h.splice(found,1)
              firestore.collection("users").doc(docId).set({
                  id: c.id,
                  name: c.name,
                  email: c.email,
                  entries: o,
                  joined: c.joined,
                  isBlocked: c.isBlocked,
                  receivedRequests: c.receivedRequests,
                  sentRequests : h
              })
              .then(function() {
                //   console.log(that.props.currentUser);
                  firestore.collection("users").where('email','==',subtractFrom).get()
          .then(function(querySnapshot) {
              querySnapshot.forEach(async function(doc) {
                  ff = doc.data()
                  docId = doc.id;
              });
              let d = parseInt(ff.entries) - parseInt(amount)
              console.log(ff.entries);
              let f = ff.receivedRequests
              const found = f.find(element => element.requestId === subtractFrom);
              f.splice(found,1)
              firestore.collection("users").doc(docId).set({
                  id: ff.id,
                  name: ff.name,
                  email: ff.email,
                  entries: d,
                  joined: ff.joined,
                  isBlocked: ff.isBlocked,
                  receivedRequests: f,
                  sentRequests : ff.sentRequests
              })
              .then(function() {
                  firestore.collection("transaction").add({
                      startid: user.email,
                      transferid: transferTo,
                      comment: "Transfered By Request",
                      points: amount,
                      date: new Date().toUTCString()
                  })
                  .then(function(docRef) {
                      fetch('https://us-central1-vqpoints.cloudfunctions.net/api/sendemail',{
                          method:'post',
                          headers: {'Content-Type': 'application/json'},
                          body: JSON.stringify({
                              id: transferTo,
                              points: parseInt(amount)
                          })
                        })
                        .then(respone=>respone.json())
                        .then(res =>{
                          console.log('complete')
                        })
                      alert("Transfer Complete")
                  })
                  .catch(function(error) {
                      console.log(error);
                      alert("Transfer Did Not Complete")
  
                  });
              })
              .catch(function(error) {
                  console.log(error);
                  alert("Transfer Did Not Complete")
  
              });
          })
          .catch(function(error) {
              console.log(error);
              alert("Transfer Did Not Complete")
  
          });
              })
              .catch(function(error) {
                  console.log(error);
                  alert("Transfer Did Not Complete")
  
              });
          })
          .catch(function(error) {
              console.log(error);
              alert("Transfer did not Complete")
          });}
    }
   onReject = (transferTo,element) => {
    var c = {}
    var docId = ''
    const {user} = this.props
    firestore.collection("users").where('email','==',transferTo).get()
        .then(function(querySnapshot) {
            querySnapshot.forEach(async function(doc) {
                c = doc.data()
                docId = doc.id;
            });
            let o = c.sentRequests
            // let d = o.indexOf(element)
            // delete o[d]
            const found = o.find(element => element.requestId === transferTo);
            // console.log(o);
            o.splice(found,1)
            // console.log(o);
            firestore.collection("users").doc(docId).set({
                id: c.id,
                name: c.name,
                email: c.email,
                entries: c.entries,
                joined: c.joined,
                isBlocked: c.isBlocked,
                receivedRequests: c.receivedRequests,
                sentRequests : o
            })
            .then(function() {
                // console.log(that.props.currentUser);
                firestore.collection("users").where('email','==',user.email).get()
        .then(function(querySnapshot) {
            querySnapshot.forEach(async function(doc) {
                c = doc.data()
                docId = doc.id;
            });
            let s = c.receivedRequests
            const found = o.find(element => element.requestId === user.email);
            // console.log(o);
            s.splice(found,1)
            
            firestore.collection("users").doc(docId).set({
                id: c.id,
                name: c.name,
                email: c.email,
                entries: c.entries,
                joined: c.joined,
                isBlocked: c.isBlocked,
                receivedRequests: s,
                sentRequests : c.sentRequests
            })
            .then(function() {
                alert("Request Rejected")
            })
            .catch(function(error) {
                // console.log(error);
                alert("Transfer Did Not Complete")

            });
        })
        .catch(function(error) {
            // console.log(error);
            alert("Transfer Did Not Complete")

        });
            })
            .catch(function(error) {
                // console.log(error);
                alert("Transfer Did Not Complete")

            });
        })
        .catch(function(error) {
            alert("Transfer did not Complete")
        });
   }
	render(){
		return(
			<div className="pa3 ba b--near-white bw2 bg-black o-60">
				<div className="overflow-auto flex flex-column items-center pa3">
					<h1 className="near-white">Received Requests</h1>
				    <table classNameName="f6 w-100 mw8 center" cellspacing="0">
				      <thead>
				        <tr className="stripe-dark">
				          <th className="fw6 tl pa3 bg-white">Requested by</th>
				          <th className="fw6 tl pa3 bg-white">Amount</th>
				          <th className="fw6 tl pa3 bg-white">Actions</th>
				        </tr>
				      </thead>
				      <tbody className="lh-copy bg-near-white">
                        {
                            this.props.user.receivedRequests.map(element => (
                                <tr>
                                <td className="pa3">{element.requestedFrom}</td>
                                <td className="pa3">{element.amount}</td>
                                <td> 
                                <button class="f6 link ph3 pv2 mb2 dib white bg-green" href="#0" onClick={()=>this.onAccept(element.requestId,element.requestedFrom,element.amount)}>Accept</button>
                                <button class="f6 link ph3 pv2 mb2 dib white bg-red" href="#0"  onClick={()=>this.onReject(element.requestId,element)}>Reject</button>
                                </td>
                                </tr>
                            ))
                        }
				      </tbody>
				    </table>
				</div>
				<div className="overflow-auto pa3 flex flex-column items-center">
					<h1 className="white">Sent Requests</h1>
				    <table classNameName="f6 w-100 mw8 center" cellspacing="0">
				      <thead>
				        <tr className="stripe-dark">
                        <th className="fw6 tl pa3 bg-white">Requested to</th>
                        <th className="fw6 tl pa3 bg-white">Amount</th>
				        </tr>
				      </thead>
				      <tbody className="lh-copy bg-near-white">
                      {
                            this.props.user.sentRequests.map(element => (
                                <tr>
                                <td className="pa3">{element.requestId}</td>
                                <td className="pa3">{element.amount}</td>
                                </tr>
                            ))
                        }
				      </tbody>
				    </table>
				</div>
			</div>
			)
		}
}

export default Requests;